var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "pt-lg-1" },
      [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _vm.selectedOffer
              ? _c("selected-offer", {
                  staticClass: "mt-2 mb-1",
                  attrs: {
                    title: _vm.selectedOffer.title,
                    "continue-without-mobile":
                      _vm.selectedOffer.continueWithoutMobile,
                    "modify-mobile-label": _vm.selectedOffer.modifyMobileLabel,
                    "modify-offer": _vm.selectedOffer.modifyOffer,
                    "offer-label": _vm.selectedOffer.offerLabel,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row align-items-end" }, [
              _c("h1", {
                staticClass: "col-12 mb-1",
                domProps: { innerHTML: _vm._s(_vm.headerTitle) },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-webview-none" },
              [
                _vm.contractInfos
                  ? _c("contract-phone-lines", {
                      staticClass: "mb-md-1 my-lg-1",
                      attrs: {
                        "contract-infos": _vm.contractInfos,
                        "contract-list-infos": _vm.contractListObjects,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.incentiveDto
              ? _c("incentive", {
                  attrs: {
                    title: _vm.incentiveDto.question,
                    text: _vm.incentiveDto.message,
                    "link-href": _vm.changerMobileLink,
                    "link-label": _vm.incentiveDto.linkLabel,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.intentionSwitchDto
              ? _c("intention-switch", {
                  staticClass: "pb-1",
                  attrs: {
                    "shop-sosh": _vm.shop === "SOSH",
                    title: _vm.intentionSwitchDto.title,
                    "inline-alert": _vm.intentionSwitchInlineAlert,
                    "acquisition-label":
                      _vm.intentionSwitchDto.acquisitionLabel,
                    "tseul-label": _vm.intentionSwitchDto.tseulLabel,
                    "changer-de-mobile-label":
                      _vm.intentionSwitchDto.changerDeMobileLabel,
                    "default-intention-checked": _vm.intentionParam,
                    "linked-with-results": true,
                  },
                  on: {
                    "switch-intention": function ($event) {
                      return _vm.switchIntention($event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.customerPopin
              ? [
                  _c("customer-popin", {
                    attrs: {
                      id: "customer-popin-id",
                      title: _vm.customerPopin.customerPopinLabelsDto.title,
                      subtitle:
                        _vm.customerPopin.customerPopinLabelsDto.subtitle,
                      text: _vm.customerPopin.customerPopinLabelsDto.text,
                      "button-label":
                        _vm.customerPopin.customerPopinLabelsDto.buttonLabel,
                      "button-link":
                        _vm.customerPopin.customerPopinLinksDto.buttonLink,
                      "link-label-html":
                        _vm.customerPopin.customerPopinLabelsDto.linkLabelHtml,
                      link: _vm.customerPopin.customerPopinLinksDto.link,
                      intention: _vm.customerPopin.intention,
                    },
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm.loading && _vm.displaySkeletonPersoReco
          ? [
              _c("skeleton-reco-mobiles-card", {
                attrs: { "with-subtitle": true },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.displayRecoMobiles
          ? [
              _c("reco-mobiles", {
                attrs: {
                  mobiles: _vm.reco.mobiles,
                  title: _vm.reco.title,
                  "sub-title": _vm.reco.subTitle,
                  shop: _vm.shop,
                  "advantage-messages": _vm.advantageMessages,
                  "data-pdb-zid": _vm.dataPdbZid,
                  "funding-details-dto": _vm.fundingDetailsDto,
                },
                on: {
                  fundingDetailsClick: _vm.handleRecoMobilesFundingDetailsClick,
                },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _vm.is5g
              ? _c("ob1-message-alerte", {
                  attrs: {
                    "is-simple-alerte": false,
                    text: _vm.banner5g.text,
                    title: _vm.banner5g.title,
                    type: "info",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row pt-1 pt-md-2",
                attrs: { id: "mobile-filters" },
              },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-5" }, [
                      _c("p", {
                        staticClass: "font-size-16 lead fw-bold pb-0",
                        attrs: { id: "total-mobiles", role: "alert" },
                        domProps: { innerHTML: _vm._s(_vm.totalMobiles) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-7 text-end" },
                      [
                        _c("ob1-liens-icone", {
                          staticClass: "noDefaultStyleButton",
                          attrs: {
                            "is-button": "",
                            "modal-id": "slide-filters-modal",
                            title: "Trier et filtrer",
                            "data-bs-toggle": "modal",
                            icon: "icon-filter",
                            type: "button",
                            "data-oevent-category": "selecteur_produit",
                            "data-oevent-action": "trier_et_filtrer",
                            "data-oevent-label": "ouverture_filtre",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 text-start" },
                  [
                    _c("selector-chips-filter", {
                      attrs: {
                        filters: _vm.filtersModelAndView,
                        "selected-status": _vm.selectedChipsStatusFilters,
                        "delete-chips-filters-label":
                          _vm.deleteChipsFiltersLabel,
                      },
                      on: {
                        "change-chips-filter": _vm.deleteFilterHandler,
                        "delete-status-filter": _vm.deleteStatusHandler,
                        "delete-range-filter": _vm.deleteRangeHandler,
                        "delete-bonus-range-filter":
                          _vm.deleteBonusRangeHandler,
                        "delete-all-chips-filter": _vm.onDeleteSelectionClick,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "slide-popin-modal" },
                  [
                    _c(
                      "slide-popin-modal-filter",
                      {
                        attrs: {
                          id: "slide-filters-modal",
                          "aria-labelledby": "slide-filters",
                        },
                      },
                      [
                        _c("selector-filters", {
                          attrs: {
                            filters: _vm.filtersModelAndView,
                            "sort-radio-buttons": _vm.sortRadioButtons,
                            "status-radio-buttons": _vm.statusModelAndView,
                            "state-label": _vm.stateLabel,
                            "search-filters-dto": _vm.searchFiltersDto,
                          },
                          on: {
                            "change-check-box": _vm.updateFiltersHandler,
                            "sort-item-click": _vm.sortHandler,
                            "status-item-click": _vm.updateStatusFilterHandler,
                          },
                        }),
                        _vm._v(" "),
                        _c("hr", {
                          staticClass: "separator separator--gray4 my-1",
                        }),
                        _vm._v(" "),
                        _c("ob1-liens-icone", {
                          staticClass: "noDefaultStyleButton my-1",
                          attrs: {
                            icon: _vm.deleteFiltersIcon,
                            "is-button": true,
                            title: _vm.selectedFiltersLabel,
                          },
                          on: { click: _vm.onDeleteSelectionClick },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm.mobiles.length === 0 && !_vm.loading
              ? _c("ob1-message-alerte", {
                  attrs: {
                    title: _vm.noResultLabel,
                    icon: "icon-info",
                    type: "info",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 px-1", attrs: { id: "devicesDisplay" } },
              [
                _vm.showSelectorCard
                  ? _c(
                      "section",
                      { staticClass: "row models-wrapper" },
                      [
                        _vm.mobiles.length !== 0 &&
                        _vm.selectorAnimationForPXF &&
                        _vm.isPxfEnabled
                          ? _c(
                              "article",
                              {
                                staticClass:
                                  "col-12 p-0 mb-1 mb-md-0 selector-card h-100 d-flex flex-column",
                              },
                              [
                                _c("pxf-animation-card", {
                                  attrs: {
                                    "is-orange": _vm.shop === "ORANGE",
                                    title: _vm.selectorAnimationForPXF.title,
                                    "sub-title":
                                      _vm.selectorAnimationForPXF.subTitle,
                                    text: _vm.selectorAnimationForPXF.text,
                                    "url-access-wording":
                                      _vm.selectorAnimationForPXF
                                        .urlAccessWording,
                                    url: _vm.selectorAnimationForPXF.url,
                                    visual: _vm.selectorAnimationForPXF.visual,
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "payment-solutions-details",
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.mobiles.slice(0, 4),
                          function (model, index) {
                            return _c(
                              "article",
                              {
                                key: model.currentVersion.ean + "-" + index,
                                staticClass:
                                  "col-12 p-0 mb-1 mb-md-0 selector-card d-flex flex-column",
                              },
                              [
                                _c("selector-card", {
                                  attrs: {
                                    model: model,
                                    "advantage-messages": _vm.advantageMessages,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex payment-solutions-details",
                                  },
                                  [
                                    model.currentVersion.dasAccessible
                                      ? _c("das-tooltip", {
                                          staticClass: "me-auto",
                                          attrs: {
                                            id: "tooltip-" + index,
                                            das: model.currentVersion
                                              .dasAccessible,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    model.currentVersion.price.price
                                      .hasInstallmentPlan
                                      ? _c("FundingDetailsLink", {
                                          attrs: {
                                            "version-seo-id":
                                              model.currentVersion.seoId.value,
                                            text: _vm.fundingDetailsDto
                                              .linkText,
                                          },
                                          on: {
                                            fundingDetailsClick:
                                              _vm.handleFundingDetailsClick,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.showSelectorAnimation &&
                        _vm.mobiles.length !== 0 &&
                        _vm.selectorAnimationDto
                          ? _c(
                              "article",
                              {
                                staticClass:
                                  "col-12 p-0 mb-1 mb-md-0 selector-card d-webview-none",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("selector-animation", {
                                      attrs: {
                                        title: _vm.selectorAnimationDto.title,
                                        "title-for-tag":
                                          _vm.selectorAnimationDto.titleForTag,
                                        text: _vm.selectorAnimationDto.text,
                                        "url-access-wording":
                                          _vm.selectorAnimationDto
                                            .urlAccessWording,
                                        url: _vm.selectorAnimationUrl,
                                        visual: _vm.selectorAnimationDto.visual,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "payment-solutions-details",
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mobiles.length >= 5
                          ? _vm._l(
                              _vm.mobiles.slice(4, _vm.mobiles.length),
                              function (model, index) {
                                return _c(
                                  "article",
                                  {
                                    key:
                                      model.currentVersion.ean +
                                      "-" +
                                      (index + 4),
                                    staticClass:
                                      "col-12 p-0 mb-1 mb-md-0 selector-card d-flex flex-column",
                                  },
                                  [
                                    _c("selector-card", {
                                      attrs: {
                                        model: model,
                                        "advantage-messages":
                                          _vm.advantageMessages,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex payment-solutions-details",
                                      },
                                      [
                                        model.currentVersion.dasAccessible
                                          ? _c("das-tooltip", {
                                              staticClass: "me-auto",
                                              attrs: {
                                                id: "tooltip-" + index + 4,
                                                das: model.currentVersion
                                                  .dasAccessible,
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        model.currentVersion.price.price
                                          .hasInstallmentPlan
                                          ? _c("FundingDetailsLink", {
                                              attrs: {
                                                "version-seo-id":
                                                  model.currentVersion.seoId
                                                    .value,
                                                text: _vm.fundingDetailsDto
                                                  .linkText,
                                              },
                                              on: {
                                                fundingDetailsClick:
                                                  _vm.handleFundingDetailsClick,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedFundingDetailVersionPrice
                  ? _c("pxf-cb4x-modal", {
                      attrs: {
                        "modal-id": "funding-details-popin",
                        "display-cb4x":
                          _vm.selectedFundingDetailVersionPrice.isCb4xAvailable,
                        "display-pxf":
                          _vm.selectedFundingDetailVersionPrice.isPxfAvailable,
                      },
                      scopedSlots: _vm._u(
                        [
                          _vm.selectedFundingDetailVersionPrice.isCb4xAvailable
                            ? {
                                key: "cb4x-content",
                                fn: function () {
                                  return [
                                    _vm.fundingDetailsDto.cb4xPopin.withFees
                                      ? _c("paying-detail-cb4x-modal-content", {
                                          attrs: {
                                            "modal-id": "funding-details-popin",
                                            "oney-merchant-guid":
                                              _vm.fundingDetailsDto.cb4xPopin
                                                .oneyMerchantGuid,
                                            "oney-widget-src":
                                              _vm.fundingDetailsDto
                                                .oneyWidgetSrc,
                                            "counter-delay":
                                              _vm.fundingDetailsDto
                                                .counterDelay,
                                            amount:
                                              _vm
                                                .selectedFundingDetailVersionPrice
                                                .totalPriceWithPromo / 100,
                                            "header-block":
                                              _vm.fundingDetailsDto.cb4xPopin
                                                .headerBlock,
                                            "how-to-benefit":
                                              _vm.fundingDetailsDto.cb4xPopin
                                                .howToBenefit,
                                            cgu: _vm.fundingDetailsDto.cb4xPopin
                                              .cgu,
                                            illustration:
                                              _vm.fundingDetailsDto.cb4xPopin
                                                .imageZen,
                                          },
                                        })
                                      : _vm.selectedFundingDetailVersionPrice
                                          .spreadingPrice4xCbWithoutFees
                                      ? _c("cb4x-modal-content", {
                                          attrs: {
                                            "header-block":
                                              _vm.fundingDetailsDto.cb4xPopin
                                                .headerBlock,
                                            "payment-block":
                                              _vm.fundingDetailsDto.cb4xPopin
                                                .paymentBlock,
                                            "payment-simulation-block":
                                              _vm.fundingDetailsDto.cb4xPopin
                                                .paymentSimulationBlock,
                                            "how-to-benefit":
                                              _vm.fundingDetailsDto.cb4xPopin
                                                .howToBenefit,
                                            faq: _vm.fundingDetailsDto.cb4xPopin
                                              .faqBlock,
                                            cgu: _vm.fundingDetailsDto.cb4xPopin
                                              .cgu,
                                            "monthly-price":
                                              _vm
                                                .selectedFundingDetailVersionPrice
                                                .spreadingPrice4xCbWithoutFees
                                                .monthlyPrice,
                                            "first-monthly-price":
                                              _vm
                                                .selectedFundingDetailVersionPrice
                                                .spreadingPrice4xCbWithoutFees
                                                .firstMonthlyPrice,
                                            "one-shot-price":
                                              _vm
                                                .selectedFundingDetailVersionPrice
                                                .spreadingPrice4xCbWithoutFees
                                                .oneShotPrice,
                                            illustration:
                                              _vm.fundingDetailsDto.cb4xPopin
                                                .imageZen,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                          _vm.selectedFundingDetailVersionPrice.isPxfAvailable
                            ? {
                                key: "pxf-content",
                                fn: function () {
                                  return [
                                    _c("pxf-modal-content", {
                                      attrs: {
                                        "header-block-dto":
                                          _vm.fundingDetailsDto.pxfPopin
                                            .headerBlockDto,
                                        "example-pxf-data":
                                          _vm.fundingDetailsDto.pxfPopin
                                            .examplePxfData,
                                        "example-pxf-tab-subtitle":
                                          _vm.fundingDetailsDto.pxfPopin
                                            .examplePxfTabSubtitle,
                                        "example-pxf-tab-title":
                                          _vm.fundingDetailsDto.pxfPopin
                                            .examplePxfTabTitle,
                                        "version-pxf-data":
                                          _vm.selectedFundingDetailVersionPrice
                                            .versionPxfData,
                                        "version-pxf-tab-title":
                                          _vm.fundingDetailsDto.pxfPopin
                                            .versionPxfTabTitle,
                                        "pxf-legal-mentions-text":
                                          _vm.fundingDetailsDto.pxfPopin
                                            .pxfLegalMentionsText,
                                        illustration:
                                          _vm.fundingDetailsDto.pxfPopin
                                            .imageZen,
                                        "financing-block":
                                          _vm.fundingDetailsDto.pxfPopin
                                            .financingBlock,
                                        cgu: _vm.fundingDetailsDto.pxfPopin
                                          .cguDto,
                                        "how-to-benefit-dto":
                                          _vm.fundingDetailsDto.pxfPopin
                                            .howToBenefitDto,
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.loading
                  ? _c(
                      "div",
                      { staticClass: "mt-1" },
                      [_c("skeleton-selector-card")],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center my-2" },
                  [
                    _vm.showMoreButton
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary mx-0",
                            attrs: {
                              id: "showMoreButton",
                              disabled: _vm.loading,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.fetchMoreMobiles()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Voir plus\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _vm.details
            ? _c(
                "div",
                [
                  _vm.details.title
                    ? _c("header-signature", {
                        staticClass: "mb-1",
                        attrs: { text: _vm.details.title },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.paragraph
                    ? _c("div", {
                        staticClass: "lead text-mw mb-1",
                        domProps: { innerHTML: _vm._s(_vm.details.paragraph) },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content-visibility-auto" },
      [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "container-fluid" },
              [_c("skeleton-mobiles-views-history-card")],
              1
            )
          : [
              _vm.mobilesViewsHistory
                ? _c("mobiles-views-history", {
                    attrs: {
                      title: _vm.navigationHistoryTitle,
                      "track-zone": _vm.viewedMobilesTag,
                      mobiles: _vm.mobilesViewsHistory.mobiles,
                      intention: _vm.intentionParam,
                    },
                  })
                : _vm._e(),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _vm.isPxfEnabled && _vm.legalMentions.pxfMention
      ? _c("div", { staticClass: "container-fluid mt-2 mb-2" }, [
          _c("p", {
            staticClass: "fw-bold",
            domProps: { innerHTML: _vm._s(_vm.legalMentions.pxfMention) },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "bg-gray2 mt-1 pt-1 pb-1" }, [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("free-hands", { attrs: { text: _vm.freeHandsText } }),
          _vm._v(" "),
          _vm.is4xCbEnabled && _vm.legalMentions.cb4xMention
            ? _c("legal-mentions4x-cb", {
                attrs: {
                  label: _vm.legalMentions.cb4xMention,
                  "popin4x-cb": _vm.legalMentions.popin4xCb,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }